module.exports = "https://trybtryb-legacy.web.app/img/tryb-light.b4beda0f.webp";